import appConf from '../app-conf'
const setup = appConf[process.env.REACT_APP_CLIENT]
const environment = process.env.NODE_ENV
const project = 'Forgot Password'
const server = null
const service = null
// const options = {
//   preference_options: [
//     { name: "Preference Type 1", value: "1" },
//     { name: "Preference Type 2", value: "2" }
//   ]
// };
const config = {
  details: {
    project,
    server,
    environment,
    service,
  },
  application: {
    account: {
      api: {
        endpoints: {
          forgotpassword: {
            headers: {
              'Content-Type': 'application/json',
              Authorization: null,
              moduleCode: setup.setup.thor.moduleCode[environment],
            },
            doc: 'https://tr4ns10.tr4ns.com/Westfield-Reporting',
            //url: "/Westfield-Reporting/report21?",
            url:
              setup.setup.api.subcard.url[environment] +
              '/tx-sub/password/forgotten',
            method: 'POST',
          },
        },
      },
      objects: {
        email: {
          name: 'email',
          initial: '',
          // placeholder: 'Email address',
          helperText: false,
          rules: ['isNotNullEmail', 'isEmail'],
        },
      },
      responses: {
        fail: 'Incorrect email or password',
        unverified: 'Please verify your account by ticking the recaptcha.',
      },
    },
  },
  routes: {
    label: 'Forgot Password',
    prefix: '/forgot_password',
  },
  setup,
}

export default config
